import { Suspense, lazy } from 'react'
import { Switch, Redirect, Route } from 'react-router-dom'
import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import virtualClassroomManagerRoutes from 'modules/virtualClassrooms/common/routing/managerRoutes'
import routes from './routes'

const { RouteChangeProgress } = common

export { routes }

export const EventList = lazy(
  () =>
    import(
      /* webpackChunkName: "VirtualClassroomManagerEventList" */ 'modules/virtualClassrooms/manager/EventList/pages/EventList'
    )
)

const EventListRouting = () => (
  <Suspense fallback={<RouteChangeProgress mode={Mode.Light} />}>
    <Switch>
      <Route exact path={routes.root} component={EventList} />
      <Redirect path='*' to={virtualClassroomManagerRoutes.events} />
    </Switch>
  </Suspense>
)

export default EventListRouting
